angular.module('leanlaw').controller('BillingTrustSummaryCtrl', ['$q', '$window', '$scope', '$state', '$stateParams', 'userService', 'leanLawApi', 'company', 'alerts', 'invoiceFilterService', function ($q, $window, $scope, $state, $stateParams, userService, leanLawApi, company, alerts, invoiceFilterService) {
  $scope.hide = hide;
  $scope.state = invoiceFilterService.state;
  $scope.selectClient = function (client) {
    if (client.client.billing.billClient) {
      $state.go("^.matter", {
        clientId: client.client.id
      });
    }
  };

  // The account <select> sits inside an ng-if, so it binds through an object to avoid shadowing
  // $scope.trust on that child scope. It holds only the id: ngOptions keeps the objects from the
  // list it first built its options from, so the account is looked up in the current detail.
  $scope.selected = {};
  $scope.selectTrust = function (trustId) {
    $scope.trust = _.find($scope.detail.accounts, a => a.id === trustId);
    $state.go(".", {
      trustId
    }, {
      notify: false
    });
  };
  $scope.report = function (account) {
    let url = $scope.me.configuration.quickbooks || "https://sandbox.qbo.intuit.com";
    url += `/app/reportv2?token=ACCTL_QUICKREPORT&date_macro=all&groupby=(Account/AccountTypeID,Account/OrderName&account=${account}`;
    $window.open(url);
  };
  $scope.isTrustAccountBroken = status => {
    const s = (status || '').toLowerCase();
    return s === 'inactive' || s === 'deleted';
  };
  $scope.trustAccountStatusMessage = (slot, status) => {
    const s = (status || '').toLowerCase();
    if (s === 'deleted') {
      return `This trust ${slot} account was deleted in QuickBooks. Recreate it in QuickBooks, or update this trust account in Settings → Trust Account Setup.`;
    }
    if (s === 'inactive') {
      return `This trust ${slot} account is inactive in QuickBooks. Reactivate it in QuickBooks, or update this trust account in Settings → Trust Account Setup.`;
    }
    return '';
  };
  activate();

  ////////////////////////

  let loadedFilter;
  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      const {
        trust
      } = $scope.me.company.settings;
      if (!$scope.me.company.settings.trustEnabled) return;
      $scope.showEvergreen = trust.evergreen;
      $scope.loadingDetail = true;
      loadSummary();
      $scope.$watch('state.filter', () => {
        reloadDetail();
      }, true);
    });

    // The deposit dialog renders into this state's own `edit` view, so this scope is
    // still alive when it saves and can refresh the table in place instead of the
    // state being rebuilt under the closing dialog. preventDefault() is what tells it
    // so -- stay silent and it falls back to reloading this state.
    $scope.$on('trust:depositRecorded', event => {
      if (!$scope.me || !$scope.me.company.settings.trustEnabled) return;
      event.preventDefault();
      loadSummary();
      reloadDetail(true);
    });
  }

  // The summary table is firm-wide, so only a deposit refreshes it; the client detail
  // follows the filter.
  let summarySeq = 0;
  let summaryLoaded = null;
  let detailSeq = 0;
  let cancelDetail = null;
  let cancelReceivables = null;

  // `force` is for a refresh the filter can't describe -- a deposit changes the
  // balances while the filter stays identical, and the dedupe below would otherwise
  // skip the re-read and leave the table showing pre-deposit figures.
  function reloadDetail(force) {
    // The filter bar publishes its defaults (e.g. "involving me") a beat after this page
    // first watches it; until then it has no scope, and loading would be a wasted read.
    if ($scope.state.filter.scope === undefined) return;
    const query = {};
    if ($scope.state.filter.scope) {
      query.scope = $scope.state.filter.scope;
    }
    if ($scope.state.filter.scopeAccount) {
      query.scopeAccount = $scope.state.filter.scopeAccount.id;
    }
    if ($scope.state.filter.matterTag) {
      query.matterTag = $scope.state.filter.matterTag;
    }
    if (!force && loadedFilter && loadedFilter.scope === query.scope && loadedFilter.scopeAccount === query.scopeAccount && loadedFilter.matterTag === query.matterTag) {
      return;
    }
    loadedFilter = query;

    // The filter sends scope=all when no person is picked, which the backend reads exactly
    // like no scope -- so that, too, is the firm-wide list the summary holds.
    const scoped = !!(query.scopeAccount || query.matterTag || query.scope && query.scope !== 'all');
    if (scoped) {
      loadDetail(query);
    } else {
      showSummaryAsDetail();
    }
  }

  // scope/scopeAccount narrow only the client list; the register and liability
  // balances stay firm-wide. The summary reconciles against those, so it always reads
  // unscoped -- a scoped read makes the client total look short.
  function loadSummary() {
    const s = ++summarySeq;
    $scope.loadingSummary = true;
    summaryLoaded = leanLawApi.listAccountingTrust({}).then(list => {
      if (list && s === summarySeq) applySummary(list);
    }).catch(err => {
      if (s === summarySeq) showError(err);
    }).finally(() => {
      if (s === summarySeq) $scope.loadingSummary = false;
    });
  }
  function loadDetail(query) {
    cancelDetailRequests();
    const d = ++detailSeq;
    cancelDetail = $q.defer();
    $scope.loadingDetail = true;
    leanLawApi.listAccountingTrust({
      ...query,
      $timeout: cancelDetail.promise
    }).then(list => {
      if (list && d === detailSeq) applyDetail(list, query);
    }).catch(err => {
      if (d === detailSeq) showError(err);
    }).finally(() => {
      if (d === detailSeq) {
        $scope.loadingDetail = false;
        cancelDetail = null;
      }
    });
  }

  // Waits on the summary's own read (in flight or done) instead of making a second one.
  function showSummaryAsDetail() {
    cancelDetailRequests();
    const d = ++detailSeq;
    $scope.loadingDetail = true;
    summaryLoaded.then(() => {
      if (d !== detailSeq) return;
      $scope.loadingDetail = false;
      if ($scope.trusts) applyDetail($scope.trusts, {});
    });
  }
  function cancelDetailRequests() {
    if (cancelDetail) {
      cancelDetail.resolve('reloading');
      cancelDetail = null;
    }
    if (cancelReceivables) {
      cancelReceivables.resolve('reloading');
      cancelReceivables = null;
    }
  }
  function applySummary(list) {
    list.undeposited = false;
    list.multiple = list.accounts.length > 1;
    list.accounts.forEach(trust => {
      trust.firmClientsTotal = sumClientBalances(trust.clients);
      trust.balanceWarning = Math.abs(trust.firmClientsTotal - trust.balance) > 0.1 || Math.abs(trust.liabilityBalance - trust.balance) > 0.1;
      if (trust.deposits) {
        list.undeposited = true;
        trust.undeposited = {
          loading: true
        };
        leanLawApi.getAccountingAccount({
          id: trust.deposits.id
        }).then(account => {
          trust.undeposited = account;
        }).catch(err => {
          alerts.error(err);
        });
      }
    });
    $scope.trusts = list;
  }
  function applyDetail(list, query) {
    list.accounts.forEach(trust => {
      trust.clients = _.sortBy(trust.clients, c => c.client.name);
      trust.clients.total = sumClientBalances(trust.clients);
    });
    $scope.detail = list;

    // Keep whichever account the user was looking at across a filter change.
    const selectedId = $scope.trust && $scope.trust.id || $stateParams.trustId;
    $scope.trust = _.find(list.accounts, a => selectedId ? a.id === selectedId : a.defaultAccount);
    if ($scope.trust) {
      $scope.selected.trustId = $scope.trust.id;
      $state.go('.', {
        trustId: $scope.trust.id
      }, {
        notify: false
      });
    }
    loadReceivables(list, query);
  }
  function loadReceivables(list, query) {
    if (cancelReceivables) {
      cancelReceivables.resolve('reloading');
    }
    const receivables = $q.defer();
    cancelReceivables = receivables;
    $scope.loadingAccounts = true;
    leanLawApi.listAccountingClients({
      ...query,
      $timeout: receivables.promise
    }).then(clientList => {
      if (!clientList || cancelReceivables !== receivables) return;
      list.accounts.forEach(trust => {
        trust.clients.forEach(client => {
          const clientAccount = _.find(clientList.clients, c => c.id === client.client.accounting.id);
          if (clientAccount) {
            client.client.accounting.balance = clientAccount.balance;
            _.each(client.matters, matter => {
              const matterAccount = _.find(clientAccount.clients, m => m.id === matter.matter.accounting.id);
              if (matterAccount) {
                matter.matter.accounting.balance = matterAccount ? matterAccount.balance : 0;
              }
            });
          }
        });
      });
    }).catch(err => {
      if (cancelReceivables === receivables) showError(err);
    }).finally(() => {
      if (cancelReceivables === receivables) {
        $scope.loadingAccounts = false;
        cancelReceivables = null;
      }
    });
  }

  // Surface the backend's specific message (e.g. which trust account is inactive/deleted in
  // QuickBooks) as the toast headline instead of a generic "An error occurred" - sc-46443.
  function showError(err) {
    alerts.error(err && err.body && err.body.message ? err.body.message : err);
  }
  function sumClientBalances(clients) {
    const cents = _.reduce(clients, (sum, c) => sum + Math.round((c.balance || 0) * 100), 0);
    return cents / 100;
  }
  function hide() {
    company.update({
      settings: {
        hideTrust: true
      }
    }).then(() => {
      $state.go('billing', {}, {
        reload: true
      });
    });
  }
}]);